import { defineComponent } from "vue";
import PtSelect from "./index.vue";
import PtOption from "./pt-option.vue";
import { selectProProps } from "./props";
export default defineComponent({
    name: "PtSelectPro",
    components: {
        PtSelect: PtSelect,
        PtOption: PtOption
    },
    props: selectProProps
});
